<div>
    <app-renderer [component]="component" [data]="data" [formGroup]="formGroup"></app-renderer>

    <div class="widget">
        <mat-slide-toggle class="withSpace" [checked]="isWYSIWYGEditorOn" color="primary" (toggleChange)="toggleWYSIWYGEditor()">
            Show WYSIWYG editor
        </mat-slide-toggle>
        <mat-slide-toggle class="withSpace" [checked]="isSettingsOn" color="primary" (toggleChange)="toggleSettings()" *ngIf="isWYSIWYGEditorOn">
            Show global settings
        </mat-slide-toggle>
        <mat-slide-toggle class="withSpace" [checked]="isTreeEditorOn" color="primary" (toggleChange)="toggleTreeEditor()" *ngIf="isWYSIWYGEditorOn">
            Show tree editor
        </mat-slide-toggle>
        <mat-slide-toggle class="withSpace" [checked]="isBordersOn" color="primary" (toggleChange)="toggleBorders()" *ngIf="isWYSIWYGEditorOn">
            Show borders
        </mat-slide-toggle>
        <mat-slide-toggle class="withSpace" [checked]="isButtonsOn" color="primary" (toggleChange)="toggleButtons()" *ngIf="isWYSIWYGEditorOn">
            Show buttons
        </mat-slide-toggle>

        <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" *ngIf="isWYSIWYGEditorOn">
            <mat-icon>add</mat-icon>
            <span>Add new</span>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item *ngFor="let compType of componentTypeKeys" (click)="add(compType)">
                <mat-icon>{{getIcon(compType)}}</mat-icon>
                <span>{{compType}}</span>
            </button>
        </mat-menu>

        <button mat-raised-button color="warn" (click)="restoreSample()" class="withSpaceLeft" *ngIf="isWYSIWYGEditorOn">
            <mat-icon>autorenew</mat-icon>
            <span>Restore</span>
        </button>
    </div>

    <div class="widget grid-editor" *ngIf="isWYSIWYGEditorOn && (isTreeEditorOn || isSettingsOn)">

        <div class="widget" *ngIf="isSettingsOn">
            <h3>Global Settings</h3>

            <mat-form-field appearance="{{appearance}}" id="ui_settings_appearance">
                <mat-label>Appearance for data components:</mat-label>
                <mat-select [(value)]="appearance" (selectionChange)="setAppearance()">
                    <mat-option value="outline">Outline</mat-option>
                    <mat-option value="fill">Fill</mat-option>
                    <mat-option value="legacy">Legacy</mat-option>
                    <mat-option value="standard">Standard</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="{{appearance}}" id="ui_settings_noOfColumns">
                <mat-label>Number of columns for root grid:</mat-label>
                <mat-select [(value)]="noOfColumns" (selectionChange)="setNoOfColumns()">
                    <mat-option value="1">1</mat-option>
                    <mat-option value="2">2</mat-option>
                    <mat-option value="3">3</mat-option>
                    <mat-option value="4">4</mat-option>
                    <mat-option value="6">5</mat-option>
                    <mat-option value="6">6</mat-option>
                    <mat-option value="7">7</mat-option>
                    <mat-option value="8">9</mat-option>
                    <mat-option value="9">9</mat-option>
                    <mat-option value="10">10</mat-option>
                    <mat-option value="11">11</mat-option>
                    <mat-option value="12">12</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-checkbox class="withSpace"
                          [checked]="isFitScreen"
                          color="primary"
                          (change)="setStretchToFit()"
                          id="ui_settings_stretchToFit">
                Stretch data inputs to fit
            </mat-checkbox>

            <button mat-raised-button color="primary" (click)="resetColspan()" class="withSpaceLeft" *ngIf="isWYSIWYGEditorOn">
                <mat-icon>grid_off</mat-icon>
                <span> Reset colspan</span>
            </button>

            <div>
                <mat-label>Grid gap: {{gridGap}}px</mat-label>
                <mat-slider
                        [(ngModel)]="gridGap"
                        (change)="setGridGap()"
                        thumbLabel
                        tickInterval="1"
                        min="1"
                        max="100">
                </mat-slider>
            </div>
        </div>

        <div class="widget" *ngIf="isTreeEditorOn">
            <tree-editor [component]="component" [data]="data" [formGroup]="formGroup"></tree-editor>
        </div>
    </div>
</div>
